export enum Roles {
    ADMIN = 'ADMIN',
    EMPLEADO = 'EMPLEADO',
    RRHH = 'RRHH',
    RRHH_PLUS = 'RRHH+',
    GERENCIA = 'GERENCIA',
    COMITE = 'COMITE',
    RECLUTAMIENTO = 'RECLUTAMIENTO',
    PREVENCIONISTA = 'PREVENCIONISTA',
    AUDITOR = 'AUDITOR'
}
